import { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();

const PdfViewer = ({
  fileUrl,
  isMobile = false,
}: {
  fileUrl: string;
  isMobile?: boolean;
}) => {
  const [numPages, setNumPages] = useState<number>(0);

  return (
    <Document
      className="w-full"
      file={fileUrl}
      onLoadSuccess={({ numPages }) => {
        setNumPages(numPages);
      }}
    >
      {Array.from({ length: numPages }, (_, i) => (
        <Page
          renderTextLayer={false}
          renderAnnotationLayer={false}
          key={i}
          pageNumber={i + 1}
          width={isMobile ? 400 : undefined}
        />
      ))}
    </Document>
  );
};

export default PdfViewer;
